import React from 'react';

const Typeform = ({ color = '#335B70', ...props }) => (
    <svg {...props} viewBox="0 0 24 24">
        <path
            fill={color}
            fillRule="evenodd"
            d="M11.707 21.999c-2.428-.034-4.528-.983-6.368-2.634-1.177-1.057-2.174-2.277-2.768-3.814-.747-1.935-.804-3.877.08-5.79a6.783 6.783 0 0 1 1.427-1.999C5.5 6.37 6.928 4.98 8.397 3.644c1.701-1.547 3.7-1.97 5.836-1.405 3.334.881 5.807 3.002 7.143 6.379 1.135 2.87.72 5.622-1.253 7.997-1.344 1.616-2.845 3.056-4.556 4.224a6.477 6.477 0 0 1-3.86 1.16ZM11.38 9.59v7.234h1.247V9.581h2.482V8.33H8.892v1.26h2.488Z"
            clipRule="evenodd"
        />
    </svg>
);

export default Typeform;
